webpackJsonp([61605834304381],{

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(8);
	
	__webpack_require__(7);
	
	var _Accordion = __webpack_require__(57);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shared = __webpack_require__(58);
	
	var _noMap = __webpack_require__(119);
	
	var _noMap2 = _interopRequireDefault(_noMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TourDisplay = function (_React$Component) {
	  _inherits(TourDisplay, _React$Component);
	
	  function TourDisplay(_ref) {
	    var items = _ref.items,
	        topLine = _ref.topLine,
	        small = _ref.small,
	        images = _ref.images,
	        text = _ref.text;
	
	    _classCallCheck(this, TourDisplay);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      items: null,
	      topLine: null,
	      small: null,
	      title: null,
	      activeTour: null,
	      groupTitle: null,
	      images: null,
	      optionsText: ""
	    };
	
	    _this.handleUpdate = function (tourTitle, groupTitle) {
	      var i, j, k, y;
	      var tourReturn = null;
	      for (i = 0, j = _this.state.items.length; i < j; i++) {
	        if (_this.state.items[i].title == groupTitle) {
	          for (k = 0, y = _this.state.items[i].tours.length; k < y; k++) {
	            if (_this.state.items[i].tours[k].title == tourTitle) {
	              tourReturn = _this.state.items[i].tours[k];
	            }
	          }
	        }
	      }
	
	      _this.setState({
	        groupTitle: groupTitle,
	        activeTour: tourReturn
	      });
	    };
	
	    _this.isActive = function (title) {
	      return _this.state.activeTour.title == title;
	    };
	
	    _this.getActiveTour = function (groupTitle, tourTitle) {
	      var i, j, k, y;
	      var tourReturn = null;
	      for (i = 0, j = _this.state.items.length; i < j; i++) {
	        if (_this.state.items[i].title == groupTitle) {
	          for (k = 0, y = _this.state.items[i].tours.length; k < y; k++) {
	            if (_this.state.items[i].tours[k].title == tourTitle) {
	              tourReturn = _this.state.items[i].tours[k];
	            }
	          }
	        }
	      }
	    };
	
	    _this.renderTourSelector = function (data, title) {
	      var tours = [];
	      var i,
	          j,
	          temparray,
	          chunk = Math.ceil(data.length / 3);
	
	      if (chunk < 5) {
	        chunk = 5;
	      }
	
	      for (i = 0, j = data.length; i < j; i += chunk) {
	        temparray = data.slice(i, i + chunk);
	        var tourTitles = temparray.map(function (tour, tourKey) {
	          return _react2.default.createElement(
	            "li",
	            { key: tour.title, style: { width: '30' } },
	            _react2.default.createElement(
	              "button",
	              {
	                onClick: function onClick(event) {
	                  _this.handleUpdate(tour.title, title);
	                },
	                className: _this.isActive(tour.title) ? "is-active" : ""
	              },
	              tour.title
	            )
	          );
	        });
	        tours.push(tourTitles);
	      }
	
	      var groups = tours.map(function (group, groupKey) {
	        return _react2.default.createElement(
	          "ul",
	          { key: groupKey, className: "c-routes__list" },
	          group
	        );
	      });
	      return _react2.default.createElement(
	        "div",
	        { className: "c-routes" },
	        groups
	      );
	    };
	
	    _this.renderTourHighlights = function () {
	      if ("highlights" in _this.state.activeTour) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h3",
	            { className: "t-h2 t-italic" },
	            "Tour Highlights Inclusions:"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "c-ws__lists mt20" },
	            _react2.default.createElement(
	              "ul",
	              { className: "t-ul" },
	              _this.state.activeTour.highlights.map(function (highlight, highlightKey) {
	                return _react2.default.createElement(
	                  "li",
	                  { key: highlightKey },
	                  highlight
	                );
	              })
	            )
	          )
	        );
	      }
	    };
	
	    _this.renderTourOptionals = function () {
	      if ("optionals" in _this.state.activeTour) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h3",
	            { className: "t-h2 t-italic" },
	            "Optional Experiences:"
	          ),
	          _react2.default.createElement(
	            "ul",
	            { className: "t-ul mt20" },
	            _this.state.activeTour.optionals.map(function (optional, optionalKey) {
	              return _react2.default.createElement(
	                "li",
	                { key: optionalKey },
	                optional
	              );
	            })
	          )
	        );
	      }
	    };
	
	    _this.getHeroImage = function () {
	      console.log(_this.state.activeTour.hero);
	      if (_this.state.activeTour.hero != null) {
	        return _this.state.activeTour.hero;
	      } else {
	        return _noMap2.default;
	      }
	    };
	
	    _this.state.items = items;
	    _this.state.topLine = topLine;
	    _this.state.small = small;
	    _this.state.groupTitle = items[0].title;
	    _this.state.activeTour = items[0].tours[0];
	    _this.state.images = images;
	    _this.state.optionsText = text;
	    return _this;
	  }
	
	  TourDisplay.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "c-golden t-context--light" },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "c-golden__short",
	          style: { display: "flex", flexDirection: "column", backgroundColor: "#eaebec" }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "c-golden__content",
	            style: { backgroundColor: "#eaebec" }
	          },
	          _react2.default.createElement(
	            "h1",
	            { className: "t-h1 mb30" },
	            this.state.optionsText
	          ),
	          _react2.default.createElement(
	            _Accordion2.default,
	            { stateReducer: _shared.single },
	            function (_ref2) {
	              var openIndexes = _ref2.openIndexes,
	                  handleItemClick = _ref2.handleItemClick;
	              return _react2.default.createElement(
	                "div",
	                {
	                  className: (0, _classnames2.default)("c-accordion", {
	                    "c-accordion--top-line": _this2.state.topLine,
	                    "c-accordion--small": _this2.state.small
	                  })
	                },
	                _this2.state.items.map(function (item, index) {
	                  return _react2.default.createElement(
	                    "div",
	                    {
	                      key: item.title,
	                      className: (0, _classnames2.default)("c-accordion__item", {
	                        "is-open": openIndexes.indexOf(index) >= 0
	                      })
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "c-accordion__btn t-h2",
	                        onClick: function onClick() {
	                          return handleItemClick(index);
	                        }
	                      },
	                      item.title
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "c-accordion__contents" },
	                      _this2.renderTourSelector(item.tours, item.title)
	                    )
	                  );
	                })
	              );
	            }
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "c-golden__images c-golden__short min-laptop",
	            style: { flex: "1" }
	          },
	          _react2.default.createElement("img", {
	            src: this.state.images[0],
	            alt: "",
	            style: { width: "50%" }
	          }),
	          _react2.default.createElement("img", {
	            src: this.state.images[1],
	            alt: "",
	            style: { width: "50%" }
	          }),
	          _react2.default.createElement("img", {
	            src: this.state.images[2],
	            alt: "",
	            style: { width: "100%" }
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "c-golden__wide" },
	        _react2.default.createElement("img", {
	          src: this.getHeroImage(),
	          alt: "",
	          style: {
	            display: "block",
	            width: "100%"
	            // height: '100%',
	            // objectFit: 'cover',
	          }
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "c-golden__content c-golden__wide" },
	          _react2.default.createElement(
	            "div",
	            { className: "c-golden__text" },
	            _react2.default.createElement(
	              "div",
	              { className: "c-golden__text-col" },
	              _react2.default.createElement(
	                "div",
	                { className: "t-map-label mb20" },
	                this.state.groupTitle
	              ),
	              _react2.default.createElement(
	                "h1",
	                { className: "t-h1" },
	                this.state.activeTour.title
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "c-ws__header mt20" },
	                _react2.default.createElement(
	                  "h2",
	                  { className: "t-h2 t-red" },
	                  this.state.activeTour.header.days,
	                  " Days /",
	                  " ",
	                  this.state.activeTour.header.nights,
	                  " Nights",
	                  _react2.default.createElement(
	                    "small",
	                    { className: "t-small" },
	                    "\xA0",
	                    this.state.activeTour.header.breakfastText
	                  )
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "t-h3 t-bold" },
	                  "Begins in ",
	                  this.state.activeTour.header.start,
	                  " and ends in",
	                  " ",
	                  this.state.activeTour.header.end
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "tour_body mt30" },
	                this.state.activeTour.body
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "c-ws__content mt20" },
	                this.renderTourHighlights(),
	                this.renderTourOptionals()
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return TourDisplay;
	}(_react2.default.Component);
	
	exports.default = TourDisplay;
	module.exports = exports["default"];

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/AlohaDiscovery.ce1a06e2.jpg";

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/AmericanRhythms.4077edc0.jpg";

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/CaliforniaDreaming.2802bd83.jpg";

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/CaliforniaExplorer.37e0cd38.jpg";

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ChicagoToLosAngeles.43d39e9b.jpg";

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ChicagoToTheGoldenGate.66533786.jpg";

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/CoastToCoast.5952a4ef.jpg";

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ColorsOfNewEngland.d1064fff.jpg";

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/DeepSouthDiscovery.69ed722d.jpg";

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/EastCoastInsider.0952ce55.jpg";

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/EasternDiscovery.b2f92190.jpg";

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FloridaSunshine.71d726d9.jpg";

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FloridaSunshineNewYork.48c8997b.jpg";

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/GoneWithTheWind.4ede827f.jpg";

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/GreatEasternCities.9dcf2763.jpg";

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/HawaiiIslandsInsider.a3440b49.jpg";

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/NationalParksExplorer.9ce89d29.jpg";

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/NationalParksTreasures.da21be07.jpg";

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/NewYorkToHollywood.66e471da.jpg";

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/NorthByNorthwest.236febc4.jpg";

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/PacificCoastExplorer.800ce71b.jpg";

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/PacificCoastExpress.003c7b76.jpg";

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/PatriotTrails.0fabeab5.jpg";

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/RhythmsOfTheSouth.57f77d76.jpg";

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/RockyMountainDiscovery.23a42b92.jpg";

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/RockyMountainFrontiers.e476ffeb.jpg";

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/RockyMountainHigh.9938170b.jpg";

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/RomanticTrailsOfTheSouth.0171ce74.jpg";

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SouthernExplorer.052528ad.jpg";

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SplendorsOfTheWest.ad362be9.jpg";

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/TheAmericanSouth.7140d75d.jpg";

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/TheGrandEast.7649700e.jpg";

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/TheGreatAmericanCrossing.a4f73be3.jpg";

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/TheSouthernBelle.6647fada.jpg";

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/TreasuresOfTheSouthwest.083b86fa.jpg";

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WestCoastAloha.f2be5444.jpg";

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WestCoastInsider.0019c89b.jpg";

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WesternBonanza.b260c816.jpg";

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WesternDiscovery.0b6e0f42.jpg";

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WesternFrontiers.ebb9e006.jpg";

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WesternHighlights.6dcdd15b.jpg";

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WesternLandscapes.206ffad3.jpg";

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WesternPanorama.219fe016.jpg";

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WesternTrails.b7c536b8.jpg";

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/escorted-tours__hero.f10b3a5c.jpg";

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/escorted_tours-1.0b8230de.jpg";

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/escorted_tours-2.0db5d372.jpg";

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/escorted_tours-3.fdc85e91.jpg";

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/escorted_tours-4.d2353cc0.jpg";

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/escorted_tours-5.fd6b05b1.jpg";

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/escorted_tours-6.e7770b9d.jpg";

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/no-map.85b31c18.jpg";

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _AlohaDiscovery = __webpack_require__(432);
	
	var _AlohaDiscovery2 = _interopRequireDefault(_AlohaDiscovery);
	
	var _AmericanRhythms = __webpack_require__(433);
	
	var _AmericanRhythms2 = _interopRequireDefault(_AmericanRhythms);
	
	var _CaliforniaDreaming = __webpack_require__(434);
	
	var _CaliforniaDreaming2 = _interopRequireDefault(_CaliforniaDreaming);
	
	var _CaliforniaExplorer = __webpack_require__(435);
	
	var _CaliforniaExplorer2 = _interopRequireDefault(_CaliforniaExplorer);
	
	var _ChicagoToLosAngeles = __webpack_require__(436);
	
	var _ChicagoToLosAngeles2 = _interopRequireDefault(_ChicagoToLosAngeles);
	
	var _ChicagoToTheGoldenGate = __webpack_require__(437);
	
	var _ChicagoToTheGoldenGate2 = _interopRequireDefault(_ChicagoToTheGoldenGate);
	
	var _CoastToCoast = __webpack_require__(438);
	
	var _CoastToCoast2 = _interopRequireDefault(_CoastToCoast);
	
	var _ColorsOfNewEngland = __webpack_require__(439);
	
	var _ColorsOfNewEngland2 = _interopRequireDefault(_ColorsOfNewEngland);
	
	var _EastCoastInsider = __webpack_require__(441);
	
	var _EastCoastInsider2 = _interopRequireDefault(_EastCoastInsider);
	
	var _EasternDiscovery = __webpack_require__(442);
	
	var _EasternDiscovery2 = _interopRequireDefault(_EasternDiscovery);
	
	var _FloridaSunshineNewYork = __webpack_require__(444);
	
	var _FloridaSunshineNewYork2 = _interopRequireDefault(_FloridaSunshineNewYork);
	
	var _FloridaSunshine = __webpack_require__(443);
	
	var _FloridaSunshine2 = _interopRequireDefault(_FloridaSunshine);
	
	var _GoneWithTheWind = __webpack_require__(445);
	
	var _GoneWithTheWind2 = _interopRequireDefault(_GoneWithTheWind);
	
	var _GreatEasternCities = __webpack_require__(446);
	
	var _GreatEasternCities2 = _interopRequireDefault(_GreatEasternCities);
	
	var _HawaiiIslandsInsider = __webpack_require__(447);
	
	var _HawaiiIslandsInsider2 = _interopRequireDefault(_HawaiiIslandsInsider);
	
	var _NationalParksExplorer = __webpack_require__(448);
	
	var _NationalParksExplorer2 = _interopRequireDefault(_NationalParksExplorer);
	
	var _NationalParksTreasures = __webpack_require__(449);
	
	var _NationalParksTreasures2 = _interopRequireDefault(_NationalParksTreasures);
	
	var _NewYorkToHollywood = __webpack_require__(450);
	
	var _NewYorkToHollywood2 = _interopRequireDefault(_NewYorkToHollywood);
	
	var _NorthByNorthwest = __webpack_require__(451);
	
	var _NorthByNorthwest2 = _interopRequireDefault(_NorthByNorthwest);
	
	var _PacificCoastExplorer = __webpack_require__(452);
	
	var _PacificCoastExplorer2 = _interopRequireDefault(_PacificCoastExplorer);
	
	var _PacificCoastExpress = __webpack_require__(453);
	
	var _PacificCoastExpress2 = _interopRequireDefault(_PacificCoastExpress);
	
	var _PatriotTrails = __webpack_require__(454);
	
	var _PatriotTrails2 = _interopRequireDefault(_PatriotTrails);
	
	var _RockyMountainDiscovery = __webpack_require__(456);
	
	var _RockyMountainDiscovery2 = _interopRequireDefault(_RockyMountainDiscovery);
	
	var _RockyMountainFrontiers = __webpack_require__(457);
	
	var _RockyMountainFrontiers2 = _interopRequireDefault(_RockyMountainFrontiers);
	
	var _RomanticTrailsOfTheSouth = __webpack_require__(459);
	
	var _RomanticTrailsOfTheSouth2 = _interopRequireDefault(_RomanticTrailsOfTheSouth);
	
	var _SouthernExplorer = __webpack_require__(460);
	
	var _SouthernExplorer2 = _interopRequireDefault(_SouthernExplorer);
	
	var _SplendorsOfTheWest = __webpack_require__(461);
	
	var _SplendorsOfTheWest2 = _interopRequireDefault(_SplendorsOfTheWest);
	
	var _TheGrandEast = __webpack_require__(463);
	
	var _TheGrandEast2 = _interopRequireDefault(_TheGrandEast);
	
	var _TheGreatAmericanCrossing = __webpack_require__(464);
	
	var _TheGreatAmericanCrossing2 = _interopRequireDefault(_TheGreatAmericanCrossing);
	
	var _TheSouthernBelle = __webpack_require__(465);
	
	var _TheSouthernBelle2 = _interopRequireDefault(_TheSouthernBelle);
	
	var _TreasuresOfTheSouthwest = __webpack_require__(466);
	
	var _TreasuresOfTheSouthwest2 = _interopRequireDefault(_TreasuresOfTheSouthwest);
	
	var _WestCoastAloha = __webpack_require__(467);
	
	var _WestCoastAloha2 = _interopRequireDefault(_WestCoastAloha);
	
	var _WestCoastInsider = __webpack_require__(468);
	
	var _WestCoastInsider2 = _interopRequireDefault(_WestCoastInsider);
	
	var _WesternBonanza = __webpack_require__(469);
	
	var _WesternBonanza2 = _interopRequireDefault(_WesternBonanza);
	
	var _WesternDiscovery = __webpack_require__(470);
	
	var _WesternDiscovery2 = _interopRequireDefault(_WesternDiscovery);
	
	var _WesternFrontiers = __webpack_require__(471);
	
	var _WesternFrontiers2 = _interopRequireDefault(_WesternFrontiers);
	
	var _WesternHighlights = __webpack_require__(472);
	
	var _WesternHighlights2 = _interopRequireDefault(_WesternHighlights);
	
	var _WesternLandscapes = __webpack_require__(473);
	
	var _WesternLandscapes2 = _interopRequireDefault(_WesternLandscapes);
	
	var _WesternPanorama = __webpack_require__(474);
	
	var _WesternPanorama2 = _interopRequireDefault(_WesternPanorama);
	
	var _WesternTrails = __webpack_require__(475);
	
	var _WesternTrails2 = _interopRequireDefault(_WesternTrails);
	
	var _RockyMountainHigh = __webpack_require__(458);
	
	var _RockyMountainHigh2 = _interopRequireDefault(_RockyMountainHigh);
	
	var _TheAmericanSouth = __webpack_require__(462);
	
	var _TheAmericanSouth2 = _interopRequireDefault(_TheAmericanSouth);
	
	var _DeepSouthDiscovery = __webpack_require__(440);
	
	var _DeepSouthDiscovery2 = _interopRequireDefault(_DeepSouthDiscovery);
	
	var _RhythmsOfTheSouth = __webpack_require__(455);
	
	var _RhythmsOfTheSouth2 = _interopRequireDefault(_RhythmsOfTheSouth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  title: "ATI Insider",
	  tours: [{
	    title: "East Coast Insider",
	    hero: _EastCoastInsider2.default,
	    header: {
	      days: 13,
	      nights: 12,
	      start: "New York",
	      end: "New York",
	      breakfastText: ""
	    },
	    highlights: ["ATI Insider Tour Director throughout", "Insider city tour of New York City featuring Manhattan’s up and coming neighborhoods", "Insider city tour of Philadelphia’s Historic Area", "Insider city tour Washington DC tour", "Visit to Gettysburg & Amish Country", "Witness the majesty of Niagara Falls", "Insider city tour of Toronto", "Insider city tour of Montréal", "Insider Walking Tour of Boston including highlights of local flavors and history", "Visit the Gilded Age Mansions in Newport"],
	    optionals: ["Scenic tour of the Manhattan Skyline by Helicopter", "Enjoy panoramic views of New York from the Observation Deck of the Famed Empire State Building", "Experience New York from the water with a Bay Cruise", "Washington D.C. night tour with dinner in posh enclave of Georgetown", "Relive colonial history at George Washington’s Mt. Vernon Estate", "Discover Niagara Falls from above and below with a lunch atop Skylon Tower and a Hornblower Cruise", "Experience the 1000 Islands aboard a scenic river cruise", "Discover dynamic Montréal during a night tour including a dinner featuring local flavors ", "Hop aboard the USS Constitution to learn more about Boston’s pivotal role in American History"],
	    body: " "
	  }, {
	    title: "West Coast Insider",
	    hero: _WestCoastInsider2.default,
	    header: {
	      days: 14,
	      nights: 13,
	      start: "San Francisco",
	      end: "San Francisco",
	      breakfastText: "(2 complimentary breakfasts)"
	    },
	    highlights: ["Insider tour of San Francisco exploring diverse neighborhoods and the city’s waterfront including a ride on the iconic Cable cars", "Thrilling and scenic bike ride across the Golden Gate Bridge and Bay Cruise", "Experience the grandeur of Yosemite National Park", "Insider evening tour of Las Vegas featuring some of the must-sees along the strip", "Witness the majesty of the Grand Canyon’s West Rim", "Visit the desert oasis and celebrity hideaway of Palm Springs", "Enjoy the relaxed coastal vibes of San Diego, with an insider city tour", "Insider Tour of Los Angeles hopping between the most famed spots and local favorites", "Walk the charming streets of Santa Barbara, known as America’s Riviera", "Discover the unforgettable Hearst Castle", "Experience the rugged Pacific coastline along Highway 1 through Big Sur", "Explore the Monterey Bay, including the coast hamlet of Carmel"],
	    optionals: ["Enjoy a Chinatown evening tour and authentic dinner", "Napa Valley Wine Tasting or Hiking Muir Woods", "Scenic helicopter ride over and into Grand Canyon", "Experience Sea World San Diego", "Dinner cruise in San Diego Bay", "Historic Queen Mary Long Beach", "Thrilling Universal Studios Hollywood", "World renowned Monterey Bay Aquarium"],
	    body: " "
	  }, {
	    title: "Hawaiian Island Insider",
	    hero: _HawaiiIslandsInsider2.default,
	    header: {
	      days: 11,
	      nights: 10,
	      start: "Honolulu",
	      end: "Maui",
	      breakfastText: " "
	    },
	    highlights: ["Traditional Flower Lei Greeting", "Comprehensive Oahu Island Tour", "Big Island Volcanoes National Park tour", "Kona Coffee Plantation tour", "Comprehensive Kauai Island tour", "Time to view Waimea Canyon and Bali Hai", "Sunset Cruise from Kaanapali Beach Maui", "Maui Island Tour"],
	    optionals: ["Traditional Hawaiian Luau", "Star Gazing from Mauna Kea", "Na Pali Coast Cruise"],
	    body: " "
	  }]
	}, {
	  title: "The East",
	  tours: [{
	    title: "The Grand East",
	    hero: _TheGrandEast2.default,
	    header: {
	      days: 20,
	      nights: 19,
	      start: "New York",
	      end: "Miami or Orlando",
	      breakfastText: " "
	    },
	    highlights: ["Welcome Reception where you will meet your fellow travelers and perhaps go out on the town together in the city that never sleeps!", "Retrace the start of the American Revolution by experiencing Boston’s historic Freedom Trail", "Travel through Vermont and New Hampshire,visiting a quintessential New England town", "Tour UNESCO world heritage sites of Old and New Quebec City", "Feel the mists while taking in the natural wonder of Niagara Falls", "Walk the hallowed grounds of Gettysburg:the most decisive battle the American Civil War", "Get an up-close taste of Amish culture at traditional farmhouse museum in Pennsylvania Dutch Country", "See the seats of power of American Government with a grand city tour of Washington, D.C.", "Stroll the National Mall witnessing its iconic Monuments Memorials", "Drive along picturesque byways crossing the Great Smokey Mountains", "Go Honky Tonkin’ and enjoy American music during a tour of Nashville", "Take in more American music culture walking down Beale Street in Memphis, home of the Blues", "Get a hands-on taste of Southern charm of the American South at the Bellingrath Estate and the Bayou Boardwalk", "Dip your toes in the crystal clear and warm waters of the Gulf of Mexico in Pensacola", "Witness first hand the ingenuity of the American space program at the Kennedy Space Center"],
	    optionals: ["Dine at a traditional Canadian Maple Sugar Farm", "Enjoy the renowned cuisine of Quebec amidst the old world charm of Montreal’s historic district", "Take in the Toronto cityscape atop the CN Tower, the largest freestanding tower in the world", "Experience Niagara Falls “up close” experience with a boat ride under the falls followed by lunch atop the Skylon Tower", "Capture the stunning lit up landmarks of Washington, D.C. with a night tour and dinner in fashionable Georgetown", "Get a little bit country at the Dolly Parton Stampede and Dinner Show", "How about a little bit more country at Nashville’s Country Hall of Fame and experience music production first hand at Studio B", "Travel back in time by exploring Elvis Presley’s eccentric estate, Graceland", "Immerse yourself in Southern history and hospitality at an Antebellum Estate and Plantation"],
	    body: "One of the most versatile tours we offer, The Grand East visits cosmopolitan cities like New York, Toronto, and New Orleans, historical places like Colonial Williamsburg or rural Amish Country, and state-of-the art places like the Kennedy Space Center which exhibits modern space-age technology."
	  }, {
	    title: "Eastern Discovery",
	    hero: _EasternDiscovery2.default,
	    header: {
	      days: 11,
	      nights: 10,
	      start: "New York",
	      end: "New York",
	      breakfastText: " "
	    },
	    highlights: ["Welcome Reception where you will meet your fellow travelers and perhaps go out on the town together in the city that never sleeps!", "Retrace the start of the American Revolution by experiencing Boston’s historic Freedom Trail", "Travel through Vermont and New Hampshire,visiting a quintessential New England town", "Tour UNESCO world heritage sites of Old and New Quebec City", "Feel the mists while taking in the natural wonder of Niagara Falls", "Walk the hallowed grounds of Gettysburg,the most decisive battle the American Civil War", "Get an up-close taste of Amish culture at traditional farmhouse museum in Pennsylvania Dutch Country", "See the seats of power of American Government with a grand city tour of Washington, D.C.", "Explore the birthplace of America in Philadelphia by seeing where it all started at Independence Hall and capturing a glimpse of the iconic Liberty Bell"],
	    optionals: ["Dine at a traditional Canadian Maple Sugar Farm", "Enjoy the renowned cuisine of Quebec amidst the old world charm of Montreal’s historic district", "Take in the Toronto cityscape atop the CN Tower, the largest freestanding tower in the world", "Experience Niagara Falls “up close” experience with a boat ride under the falls followed by lunch atop the Skylon Tower", "Capture the stunning lit up landmarks of Washington, D.C. with a night tour and dinner in fashionable Georgetown"],
	    body: "A memorable excursion from sophisticated Manhattan and cultural Boston to cosmopolitan Montreal and inspiring national monuments in D.C."
	  }, {
	    title: "Southern Explorer",
	    hero: _SouthernExplorer2.default,
	    header: {
	      days: 14,
	      nights: 13,
	      start: "New York",
	      end: "Miami or Orlando",
	      breakfastText: ""
	    },
	    highlights: ["Explore the birthplace of America in Philadelphia by seeing where it all started at Independence Hall and capturing a glimpse of the iconic Liberty Bell", "See the seats of power of the US Government with a grand city tour of Washington, D.C.", "Stroll the National Mall witnessing its iconic Monuments Memorials", "Drive along picturesque byways crossing the Great Smokey Mountains", "Go Honky Tonkin’ and enjoy American music during a tour of Nashville", "Take in more American music culture walking down Beale Street in Memphis, home of the Blues", "Get a hands-on taste of Southern charm of the American South at the Bellingrath Estate and the Bayou Boardwalk", "Dip your toes in the crystal clear and warm waters of the Gulf of Mexico in Pensacola", "Witness first hand the ingenuity of the American space program at the Kennedy Space Center "],
	    optionals: ["Capture the stunning lit up landmarks of Washington, D.C. with a night tour and dinner in fashionable Georgetown", "Get a little bit country at the Dolly Parton Stampede and Dinner Show", "How about a little bit more country at Nashville’s Country Hall of Fame and experience music production first hand at Studio B", "Travel back in time by exploring Elvis Presley’s eccentric estate, Graceland", "Immerse yourself in Southern history and hospitality at an Antebellum Estate and Plantation"],
	    body: "Forests, swamps and bayous, combined with high mountain peaks, exciting Cajun-style cities and the laid-back relaxation of South Florida make this a very well-rounded tour."
	  }, {
	    title: "Patriot Trails",
	    hero: _PatriotTrails2.default,
	    header: {
	      days: 9,
	      nights: 8,
	      start: "Boston",
	      end: "New York",
	      breakfastText: " "
	    },
	    highlights: ["Welcome Reception and meet your fellow travelers", "Retrace the start of the American Revolution by experiencing Boston’s historic Freedom Trail", "Travel through Vermont and New Hampshire,visiting a quintessential New England town", "Tour UNESCO world heritage sites of Old and New Quebec City", "Feel the mists while taking in the natural wonder of Niagara Falls", "Walk the hallowed grounds of Gettysburg, the most decisive battle the American Civil War", "Get an up-close taste of Amish culture at traditional farmhouse museum in Pennsylvania Dutch Country", "See the seats of power of the AmericanGovernment with a grand city tour ofWashington, D.C.", "Explore the birthplace of America in Philadelphia by seeing where it all started at Independence Hall and capturing a glimpse of the iconic Liberty Bell"],
	    optionals: ["Dine at a traditional Canadian Maple Sugar Farm", "Enjoy the renowned cuisine of Quebec amidst the old world charm of Montreal’s historic district", "Take in the Toronto cityscape atop the CN Tower, the largest freestanding tower in the world", "Experience Niagara Falls “up close” experience with a boat ride under the falls followed by lunch atop the Skylon Tower", "Capture the stunning lit up landmarks of Washington, D.C. with a night tour followed by a with dinner in fashionable Georgetown"],
	    body: "From the Freedom Trail of Boston to the city of Quebec, this journey takes you through two nations which offer cosmopolitan cities and natural wonders."
	  }, {
	    title: "Great Eastern Cities",
	    hero: _GreatEasternCities2.default,
	    header: {
	      days: 8,
	      nights: 7,
	      start: "New York",
	      end: "New York or Philadelphia",
	      breakfastText: " "
	    },
	    highlights: ["Become a part of the hustle and bustle of Manhattan with a morning tour of its many iconic sites, including Times Square", "Taste the wines of upstate New York while stopping at Watkins Glen in the Finger Lakes", "Feel the mists while taking in the natural wonder of Niagara Falls", "Walk the hallowed grounds of Gettysburg,the most decisive battle the American Civil War", "See the seats of power of American Government with a grand city tour of Washington, D.C.", "Explore the birthplace of America in Philadelphia by seeing where it all started at Independence Hall and capturing a glimpse of the iconic Liberty Bell"],
	    optionals: ["Take a cruise around New York Bay enjoying fabulous views of the Statue of Liberty", "Relive your American film memory with a ride to the top of the iconic Empire State Building", "Experience Niagara Falls “up close” experience with a boat ride under the falls followed by lunch atop the Skylon Tower", "Capture the stunning lit up landmarks of Washington, D.C. with a night tour followed by a with dinner in fashionable Georgetown", "Experience quintessential home cooking in America’s oldest operating tavern in Philadelphia"],
	    body: "This is a memorable excursion from sophisticated Manhattan and thundering Niagara to the Pennsylvania Dutch countryside and the inspiring national monuments in D.C."
	  }, {
	    title: "Colors of New England",
	    hero: _ColorsOfNewEngland2.default,
	    header: {
	      days: 10,
	      nights: 9,
	      start: "Boston",
	      end: "Boston",
	      breakfastText: " "
	    },
	    highlights: ["Capture New England’s coastline and perhaps Instagram one of America’s most photographed lighthouses", "Drive through Kennebunkport, a Summer retreat for American political elites", "Experience that natural wonder of Acadia National Park and traverse to the top of Cadillac Mountain", "Witness the fall foliage change colors as your drive through Vermont’s White Mountains", "Ride the Cannon Mountain Aerial Tramway for spectacular views (weather permitting)", "Savor the flavors of famed Vermont cheese and sweet maple syrup", "Take in the culture of America’s Quakers with an up-close tour of the Hancock Shaker Village", "Relive the splendor and opulence of America’s Gilded Age with a Mansion tour in Newport", "Go back to the beginning of the American colonies with a photo opportunity at Plymouth Rock, landing spot of the Mayflower", "Retrace the start of the American Revolution by experiencing Boston’s historic Freedom Trail"],
	    optionals: ["Dine like a local at a Maine boiled lobster dinner", "Enjoy the flavors of a traditional New England Clambake", "Hop aboard a ferry to another all American summer retreat, Martha’s Vineyard, where you can bike along the scenic coastal pathway (weather permitting)", "Enjoy lunch at the famous Von Trapp Lodge,a unique mountain resort surrounded by beautiful fall foliage", "Hop aboard one of New England’s First and Finest Whale Watch vessels and enjoy Marine Life Adventures", "Visit the grounds of renowned Harvard University followed by a farewell dinner in Boston"],
	    body: "Visit four states on this tour which takes you on a historical trip around some of America's famous landmarks. Visit quaint Cape Cod, taste authentic maple syrup and take a gander at the majestic Green and White Mountains."
	  }]
	}, {
	  title: "The South",
	  tours: [{
	    title: "The American South",
	    hero: _TheAmericanSouth2.default,
	    header: {
	      days: 14,
	      nights: 13,
	      start: "Atlanta",
	      end: "Atlanta",
	      breakfastText: "(4 complimentary breakfasts)"
	    },
	    highlights: ["Welcome reception and meeting of fellow travelers", "Visit Stately Oaks Plantation and museum, the inspiration for “Tara” from Gone with the Wind", "Sight-seeing tour of Atlanta including MLK’s boyhood home and visitors’ center", "Tour historic Charleston and see the iconic piazzas of the beautiful homes", "Travel to Beaufort, the filming site of the movie Forest Gump", "Trolley Tour the historic downtown district of Savannah", "Experience historic landmarks of the Civil Rights Trail in Montgomery and Selma, Alabama", "See New Orleans, home to jazz and beignets", "See and visit a lavish Antebellum-styled Mansion in Natchez", "Sightseeing of Memphis: including the Lorraine Hotel, MLK assassination site, and Beale Street, home of the Blues", "Tour Nashville and go Honky Tonkin’", "See the renowned Chatanooga Choo Choo"],
	    optionals: ["Tour and explore Boone Hall Plantation", "Take a riverboat dinner cruise of Savannah", "Traditional Steamboat Jazz Cruise on the Mississippi River", "Swamp tour and jazz brunch in New Orleans", "Explore Elvis Presley’s magnificent Estate: Graceland", "Tour Nashville’s Country Hall of Fame and Studio B"],
	    body: "Considered its own distinct place, the American South is defined by its hospitality, cuisine, landscape, music and history.  Comprised of the nation's southernmost states, this region is deeply in tune with the American experience.  From Atlanta and Nashville to Charleston and New Orleans, this is a journey through America's unique cultural landscape."
	  }, {
	    title: "Deep South Discovery",
	    hero: _DeepSouthDiscovery2.default,
	    header: {
	      days: 9,
	      nights: 8,
	      start: "Atlanta",
	      end: "New Orleans",
	      breakfastText: "(3 complimentary breakfasts)"
	    },
	    highlights: ["Welcome Reception and meet your fellow travelers", "Visit Stately Oaks Plantation and museum, the inspiration for “Tara” from Gone with the Wind", "Sight-seeing tour of Atlanta including MLK’s boyhood home and visitors’ center", "Tour historic Charleston and see the iconic piazzas of the beautiful homes", "Travel to Beaufort, the filming site of the movie Forest Gump", "Trolley Tour the historic downtown district of Savannah", "Experience historic landmarks of the Civil Rights Trail in Montgomery and Selma, Alabama", "See New Orleans, home to jazz and beignets"],
	    optionals: ["Tour and explore Boone Hall Plantation", "Take a riverboat dinner cruise of Savannah", "Traditional Steamboat Jazz Cruise on the Mississippi River", "Swamp tour and jazz brunch in New Orleans"],
	    body: "A small universe with a shared history between several states, the Deep South moves to slower, more relaxed rhythm, profoundly connected to its past but always looking to the future.  From plantations and horse-drawn carriages, to steamboats on the Mississippi and battles for civil rights, the nation's southernmost states all bear an irresistible charm just waiting to be explored."
	  }, {
	    title: "Rhythms of the South",
	    hero: _RhythmsOfTheSouth2.default,
	    header: {
	      days: 8,
	      nights: 7,
	      start: "New Orleans",
	      end: "Atlanta",
	      breakfastText: "(1 complimentary breakfast)"
	    },
	    highlights: ["See New Orleans, home to jazz and beignets", "See and visit a lavish Antebellum-styled Mansion in Natchez", "Sightseeing of Memphis: including the Lorraine Hotel, MLK assassination site, and Beale Street, home of the Blues", "Tour Nashville and go Honky Tonkin’", "See the renown Chatanooga Choo Choo"],
	    optionals: ["Traditional Steamboat Jazz Cruise on the Mississippi River", "Swamp tour and jazz brunch in New Orleans", "Explore Elvis Presley’s magnificent Estate: Graceland", "Tour Nashville’s Country Hall of Fame and Studio B"],
	    body: "Shake, rattle and roll your way through the big hearted, musically influenced southern cities of America. Music is interwoven into the heart of each city and helps tell a bigger story of its past and present.  From New Orleans' jazz and Nashville's country, to Memphis' blues and Atlanta's rap, you're sure to enjoy the music and musicians who have defined these legendary cities."
	  }, {
	    title: "American Rhythms",
	    hero: _AmericanRhythms2.default,
	    header: {
	      days: 8,
	      nights: 7,
	      start: "Nashville",
	      end: "New Orleans",
	      breakfastText: " "
	    },
	    highlights: ["Walking tour of Nashville with ATI Local Expert", "Fully guided tour of Memphis", "New Orleans and French Quarter tour", "Fully escorted from Day 3 to Day 7"],
	    optionals: ["Grand Old Opry Show", "Nashville Night tour and dinner", "Graceland Tour", "Mississippi River Boat cruise and jazz dinner", "Oak Alley Plantation and Swamp tour", "New Orleans School of Cooking"],
	    body: "Feel the distinct rhythm of the South from the lively French Quarter and bayou swamps to the Country Music Hall of Fame and Graceland."
	  }, {
	    title: "Florida Sunshine",
	    hero: _FloridaSunshine2.default,
	    header: {
	      days: 7,
	      nights: 6,
	      start: "Miami",
	      end: "Miami",
	      breakfastText: "(Daily Breakfast)"
	    },
	    highlights: ["City tour of vibrant Miami", "Excursion through the beautiful Florida Keys and explore Key West", "See America’s tiniest post office (driving conditions permitting)", "Tour Everglades National Park and ride an airboat along the “river of grass”", "See the alligator and reptile show", "Drive through Sarasota, home of the historic Ringling Brothers’ American Circus", "Visit Kennedy Space Center and get an up-close, hands-on taste for space travel", "Daily Breakfast Included"],
	    optionals: ["See the Florida Keys at sunset aboard a catamaran", "Ride the historic Conch Train and discover Florida’s most southern city", "Explore downtown Orlando including a boat ride on a scenic lake", "Visit Orlando’s world renown theme parks"],
	    body: "Come bask in the warm glow of the beautiful Florida sun!  You'll see beaches galore, and have a chance to visit the Walt Disney World Resort."
	  }, {
	    title: "Florida Sunshine & New York",
	    hero: _FloridaSunshineNewYork2.default,
	    header: {
	      days: 10,
	      nights: 9,
	      start: "New York",
	      end: "Miami",
	      breakfastText: "(Daily Breakfast)"
	    },
	    highlights: ["Morning sightseeing tour of iconic Manhattan including Times Square", "Leisure time for shopping, strolling or exploring the Big Apple", "City tour of vibrant Miami", "Excursion through the beautiful Florida Keys and explore Key West", "See America’s tiniest post office (driving conditions permitting)", "Tour Everglades National Park and ride an airboat along the “river of grass”", "See the alligator and reptile show", "Drive through Sarasota, home of the historic Ringling Brothers’ American Circus", "Visit Kennedy Space Center and get an up-close, hands-on taste for space travel", "Daily Breakfast Included"],
	    optionals: ["Take a cruise of the Hudson River and enjoy fabulous views of the Statue of Liberty", "Ride to the top of the Empire State Building", "See the Florida Keys at sunset aboard a catamaran", "Ride the historic Conch Train and discover Florida’s most southern city", "Explore downtown Orlando including a boat ride on a scenic lake", "Visit Orlando’s world renown theme parks"],
	    body: "After two full days of seeing the sights in the Big Apple come bask in the warm glow of the beautiful Florida sun!  You'll see beaches galore, and have a chance to visit the Walt Disney World Resort."
	  }]
	}, {
	  title: "Transcontinental",
	  tours: [{
	    title: "The Great American Crossing",
	    hero: _TheGreatAmericanCrossing2.default,
	    header: {
	      days: 20,
	      nights: 19,
	      start: "New York",
	      end: "San Francisco",
	      breakfastText: " "
	    },
	    highlights: ["Welcome Drink", "Explore the birthplace of America:Philadelphia and visit the Liberty Bell", "Grand city tour of Washington DC", "Stroll the National Mall and its famous Memorials: Lincoln, Washington and more....", "Experience Gettysburg: the most famous battle site in the American Civil War", "Visit Niagara Falls and renown Floral Clock with Westminster Chimes", "Visit the Henry Ford Museum and an automobile production plant", "Orientation tour of downtown Chicago including Lake Shore Drive, Navy Pier & the Magnificent Mile", "See the famous carving of the 4 American Presidents’ faces: Washington, Jefferson, Lincoln and Roosevelt at Mount Rushmore", "Discover the world’s first National Park: Yellowstone", "Tour Salt Lake City including Temple Square,home to the Mormon Tabernacle", "Explore Bryce Canyon National Park", "Travel the historic Route 66, stopping at the iconic town of Seligman", "Photo stop at the landmark “Welcome to Las Vegas” sign", "Travel across the Mojave Desert and see its indigenous Joshua Trees", "Orientation tour of Los Angeles including stops at some of its most famous spots", "See Hollywood and its ‘Sidewalk of the Stars’", "Travel California’s central coast and its rich agricultural plains", "Visit Monterey including Cannery Row, inspiration for American author John Steinbeck", "Journey through one of America’s most renown technology hubs: Silicon Valley"],
	    optionals: ["Washington Night Tour with dinner in fashionable Georgetown", "Enjoy a Niagara Falls “close up” experience: a boat ride at it base followed by lunch atop the Skylon Tower", "Enjoy a river cruise in Chicago, seeing the works of famous American architects", "Ride to the top of Willis Tower and enjoy the spectacular view (weather permitting)", "Dinner at the Roof Restaurant in Salt Lake City with panoramic views of Temple Square", "Dinner and boot stompin’ fun to cowboy music at Bryce Canyon", "Grand Canyon helicopter flight", "Fly over Lake Powell and enjoy a Monument Valley tour", "Las Vegas evening Tour", "Dinner at Bubba Gump’s in Long Beach", "Visit Universal Studios"],
	    body: "Ever dream of traveling completely across America to see what makes it so unique? Here is your chance!"
	  }, {
	    title: "New York to Hollywood",
	    hero: _NewYorkToHollywood2.default,
	    header: {
	      days: 17,
	      nights: 16,
	      start: "New York",
	      end: "San Francisco",
	      breakfastText: " "
	    },
	    highlights: ["Welcome Drink", "Explore the birthplace of America:  Philadelphia and visit the Liberty Bell", "Grand city tour of Washington DC", "Stroll the National Mall and its famous Memorials:  Lincoln, Washington and more....", "Experience Gettysburg: the most famous battle site in the American Civil War", "Visit Niagara Falls and renown Floral Clock with Westminster Chimes", "Visit the Henry Ford Museum and an automobile production plant", "Orientation tour of downtown Chicago including Lake Shore Drive, Navy Pier & the Magnificent Mile", "See the famous carving of the 4 American Presidents’ faces: Washington, Jefferson, Lincoln and Roosevelt at Mount Rushmore", "Discover the world’s first National Park: Yellowstone", "Tour Salt Lake City including Temple Square,home to the Mormon Tabernacle", "Explore Bryce Canyon National Park", "Travel the historic Route 66, stopping at the iconic town of Seligman", "Photo stop at the landmark “Welcome to Las Vegas” sign", "Travel across the Mojave Desert and see its indigenous Joshua Trees", "Orientation tour of Los Angeles including stops at some of its most famous spots", "See Hollywood and its ‘Sidewalk of the Stars’"],
	    optionals: ["Washington Night Tour with dinner in fashionable Georgetown", "Enjoy a Niagara Falls “close up” experience:  a boat ride at it base followed by lunch atop the Skylon Tower", "Enjoy a river cruise in Chicago, seeing the works of famous American architects", "Ride to the top of Willis Tower and enjoy the spectacular view (weather permitting)", "Dinner at the Roof Restaurant in Salt Lake City with panoramic views of Temple Square", "Dinner and boot stompin’ fun to cowboy music at Bryce Canyon", "Grand Canyon helicopter flight", "Fly over Lake Powell and enjoy a Monument Valley tour", "Las Vegas evening Tour"],
	    body: "This journey from sea to shining sea connects the two major entertainment centers of the country, while providing an adventure worthy of a Hollywood movie."
	  }, {
	    title: "Chicago to the Golden Gate",
	    hero: _ChicagoToTheGoldenGate2.default,
	    header: {
	      days: 14,
	      nights: 13,
	      start: "Chicago",
	      end: "San Francisco",
	      breakfastText: " "
	    },
	    highlights: ["Enjoy an orientation tour of downtown Chicago including Lake Shore Drive, Navy Pier & the Magnificent Mile", "See the famous carving of the 4 American Presidents’ faces: Washington, Jefferson, Lincoln and Roosevelt at Mount Rushmore", "Discover the world’s first National Park: Yellowstone", "Tour Salt Lake City including Temple Square,home to the Mormon Tabernacle", "Explore Bryce Canyon National Park", "Travel the historic Route 66, stopping at the iconic town of Seligman", "Photo stop at the landmark “Welcome to Las Vegas” sign", "Travel across the Mojave Desert and see its indigenous Joshua Trees", "Orientation tour of Los Angeles including stops at some of its most famous spots", "See Hollywood and its ‘Sidewalk of the Stars’", "Travel California’s central coast and its rich agricultural plains", "Visit Monterey including Cannery Row, inspiration for American author John Steinbeck", "Journey through one of America’s most renown technology hubs: Silicon Valley"],
	    optionals: ["Enjoy a river cruise in Chicago, seeing the works of famous American architects", "Ride to the top of Willis Tower and enjoy the spectacular view (weather permitting)", "Dinner at the Roof Restaurant in Salt Lake City with panoramic views of Temple Square", "Dinner and boot stompin’ fun to cowboy music at Bryce Canyon", "Grand Canyon helicopter flight", "Fly over Lake Powell and enjoy a Monument Valley tour", "Las Vegas Night Tour", "Dinner at Bubba Gump’s in Long Beach", "Visit Universal Studios"],
	    body: "An exciting excursion from the Windy City on the shores of Lake Michigan to the popular destination of cosmopolitan San Francisco, the famed City by the Bay."
	  }, {
	    title: "Chicago to L.A.",
	    hero: _ChicagoToLosAngeles2.default,
	    header: {
	      days: 11,
	      nights: 10,
	      start: "Chicago",
	      end: "Los Angeles",
	      breakfastText: " "
	    },
	    highlights: ["Enjoy an orientation tour of downtown Chicago including Lake Shore Drive, Navy Pier & the Magnificent Mile", "See the famous carving of the 4 American Presidents’ faces: Washington, Jefferson, Lincoln and Roosevelt at Mount Rushmore", "Discover the world’s first National Park: Yellowstone", "Tour Salt Lake City including Temple Square, home to the Mormon Tabernacle", "Explore Bryce Canyon National Park", "Travel the historic Route 66, stopping at the iconic town of Seligman", "Photo stop at the landmark “Welcome to Las Vegas” sign", "Travel across the Mojave Desert and see its indigenous Joshua Trees", "Orientation tour of Los Angeles including stops at some of its most famous spots", "See Hollywood and its ‘Sidewalk of the Stars’"],
	    optionals: ["Enjoy a river cruise in Chicago, seeing the works of famous American architects", "Ride to the top of Willis Tower and enjoy the spectacular view (weather permitting)", "Dinner at the Roof Restaurant in Salt Lake City with panoramic views of Temple Square", "Dinner and boot stompin’ fun to cowboy music at Bryce Canyon", "Grand Canyon helicopter flight", "Fly over Lake Powell and enjoy a Monument Valley tour", "Las Vegas evening tour"],
	    body: "An exciting excursion from the Windy City on the shores of Lake Michigan, all the way to America's second largest city on the Pacific Coast."
	  }, {
	    title: "Coast to Coast",
	    hero: _CoastToCoast2.default,
	    header: {
	      days: 14,
	      nights: 13,
	      start: "New York",
	      end: "Los Angeles",
	      breakfastText: " "
	    },
	    highlights: ["Morning sightseeing tour of iconic Manhattan including Times Square", "Travel the wine country of upstate New York and stop for Wine tasting in Watkins Glen", "Visit Niagara Falls and renown Floral Clock with Westminster Chimes", "Experience Gettysburg: the most famous battle site in the American Civil War", "Day sightseeing tour of San Diego", "Visit “Hollywood’s desert retreat”: Palm Springs", "Gaze at the majestic Grand Canyon", "Tour a Navajo Indian Reservation and stop at Monument Valley", "Explore Bryce Canyon National Park", "Leisure time in vibrant Las Vegas", "Photo stop at the landmark “Welcome to Las Vegas” sign"],
	    optionals: ["Take a cruise of the Hudson River and enjoy fabulous views of the Statue of Liberty", "Ride to the top of the Empire State Building", "Visit Niagara Falls and renown Floral Clock with Westminster Chimes", "Washington Night Tour with dinner in fashionable Georgetown", "Harbor Cruise of San Diego", "Flights over the magnificent Grand Canyon", "Jeep tour in Monument Valley", "Antelope Canyon excursion", "Boot stompin’ dinner and fun at Ebenezer’s Barn & Grill", "Las Vegas evening tour"],
	    body: "This tour from the East Coast to the West connects the two major entertainment centers of the country, while stopping at some of the most interesting spots on both coasts."
	  }]
	}, {
	  title: "The Rockies",
	  tours: [{
	    title: "Rocky Mountain Frontiers",
	    hero: _RockyMountainFrontiers2.default,
	    header: {
	      days: 15,
	      nights: 14,
	      start: "Denver",
	      end: "Denver",
	      breakfastText: ""
	    },
	    highlights: ["Enjoy a welcome reception where you will meet your fellow travelers", "Travel along the America’s highest highway through Rocky Mountain National Park", "Go back in time to the wild west with a visit to historic Fort Laramie an important military outpost during America’s westward expansion", "Travel along the famed Oregon trail, the route many pioneers traversed to settle the American West", "Capture a moment in front of Mount Rushmore,a mountain carving of four American Presidents - Washington, Jefferson, Lincoln and Roosevelt", "Discover the vast natural bounty and majesty world’s first National Park: Yellowstone", "Witness the stunning rugged peaks of the Grand Teton Mountain Range", "Experience Salt Lake City including Temple Square, home to the Mormon Tabernacle", "Capture the unique mountain landscapes and unique rock formations of Arches and Canyonlands National Parks", "Traverse the ancestral and present day lands of the Navajo tribe", "Take in the spectacular scenery of red rocks while discovering Colorado’s ‘Garden of the Gods’", "Experience the diverse culture, cuisine, and landscapes of the American Rockies and Southwest"],
	    optionals: ["Hop aboard a covered wagon ride and enjoy a cowboy cookout while in Jackson Hole, Wyoming", "Take in the panoramic views of Temple Square during a rooftop dinner in Salt Lake City", "Get a little adventurous with jet boat ride on the Colorado River", "Explore both the natural and manmade beauty of Canyon de Chelly with a local Navajo guide", "Taste traditional Southwestern cuisine in Albuquerque, New Mexico"],
	    body: "Travel through the western frontier and be awestruck by the scenery of the Rocky Mountains, Yellowstone, Grand Teton, Arches National Park and Garden of the Gods. Relive the stories of the Old West in Cheyenne and Cody, marvel at the sight of Mount Rushmore and explore a multitude of other must-see destinations along the way."
	  }, {
	    title: "Treasures of the Southwest",
	    hero: _TreasuresOfTheSouthwest2.default,
	    header: {
	      days: 8,
	      nights: 7,
	      start: "Salt Lake City",
	      end: "Denver",
	      breakfastText: " "
	    },
	    highlights: ["Capture the unique desert landscapes of Arches and Canyonlands National Parks", "Traverse the ancestral and present day lands of the Navajo tribe", "Take in the spectacular scenery of red rocks while discovering Colorado’s ‘Garden of the Gods’", "Experience the diverse culture, cuisine,and landscapes of the American Rockies and Southwest"],
	    optionals: ["Take in the panoramic views of Temple Square during a rooftop dinner in Salt Lake City", "Get a little adventurous with jet boat ride on the Colorado River", "Explore both the natural and manmade beauty of Canyon de Chelly with a local Navajo guide", "Taste traditional Southwestern cuisine in Albuquerque, New Mexico"],
	    body: "Experience the Southwest in ways you've never imagined.  From magnificent natural scenery to varied and unique cultures, this venture immerses you in the beauty of the area and is an experience you'll treasure for a lifetime."
	  }, {
	    title: "Rocky Mountain High",
	    hero: _RockyMountainHigh2.default,
	    header: {
	      days: 8,
	      nights: 7,
	      start: "Denver",
	      end: "Salt Lake City",
	      breakfastText: " "
	    },
	    highlights: ["Enjoy a welcome reception where you will meet your fellow travelers", "Travel along the America’s highest highway through Rocky Mountain National Park", "Go back in time to the wild west with a visit to historic Fort Laramie an important military outpost during America’s westward expansion", "Travel along the famed Oregon trail, the route many pioneers traversed to settle the American West", "Capture a moment in front of Mount Rushmore,a mountain carving of four American Presidents - Washington, Jefferson, Lincoln and Roosevelt", "Discover the vast natural bounty and majesty world’s first National Park: Yellowstone", "Witness the stunning rugged peaks of the Grand Teton Mountain Range", "Experience Salt Lake City including Temple Square, home to the Mormon Tabernacle"],
	    optionals: ["Hop aboard a covered wagon ride and enjoy a cowboy cookout while in Jackson Hole, Wyoming", "Take in the panoramic views of Temple Square during a rooftop dinner in Salt Lake City"],
	    body: "Outdoor adventure awaits in one of the most beautiful regions of North America.  Make lifetime memories as you experience a range of activities, destinations of extraordinary natural beauty, an abundance of wildlife and numerous historic sights during this journey through America's west."
	  }]
	}, {
	  title: "The West",
	  tours: [{
	    title: "Western Discovery",
	    hero: _WesternDiscovery2.default,
	    header: {
	      days: 15,
	      nights: 14,
	      start: "Los Angeles",
	      end: "Los Angeles",
	      breakfastText: " "
	    },
	    highlights: ["Enjoy a welcome reception where you will meet your fellow travelers", "Experience the low key coastal vibes of San Diego during day long sightseeing tour of the city", "Discover the famed mid-century architecture of “Hollywood’s desert retreat” during a visit to Palm Springs", "Gaze at the majesty of the Grand Canyon", "Relive American western film history, witnessing the iconic western landscapes of Monument Valley", "Capture the unique rock formations of Bryce Canyon National Park", "Enjoy leisure time for shopping, gambling, eating, or all of the above in glitzy Las Vegas", "Post an Instagram of yourself at the iconic “Welcome to Las Vegas” sign", "Traverse the lowest and driest spot within the western hemisphere: Death Valley National Park", "Explore the magnificent falls during a visit to majestic Yosemite National Park (weather permitting)", "Take in the sites of the City by the Bay, San Francisco, including the Golden Gate Bridge, Union Square and Fisherman’s Wharf", "Journey through America’s capital of technology innovation, Silicon Valley", "Experience the charming sites and sounds of Monterey including Cannery Row, inspiration for American author John Steinbeck", "Discover through the picturesque scenery of California’s central coast and its rich agricultural plains", "Enjoy a touch of Europe in the new world while visiting the Danish community of Solvang", "Stroll the Hollywood Walk of Fame and find your favorite celebrity’s star", "Get a glimpse of all the glamour Los Angeles has to offer with stops at some of its most famous spots"],
	    optionals: ["Hop on a harbor cruise of San Diego Bay", "Take flight over the magnificent Grand Canyon for unforgettable experience", "Jump into a Jeep and taking an in depth tour of Monument Valley", "Capture the intense colors and ethereal light of Antelope Canyon", "How about a boot stompin’ dinner with country music fun at Ebenezer’s Barn in Bryce Canyon", "Experience the glitz and glam of Las Vegas during an extensive evening tour", "Take a gondola ride to the summit Mammoth Mountain for a breakfast with sweeping views of the Sierra Mountains", "Hop on board a cable car during an extensive night tour of San Francisco and enjoy dinner tonight in the “City by the Bay”", "Ride a bike across the Golden Gate Bridge with vast views of the San Francisco Bay", "Enjoy a seafood feast during a Bubba Gump lunch at Santa Monica’s pier, the finish line of famed Route 66"],
	    body: "This is an exquisitely diverse excursion from Los Angeles which includes unparalleled canyon vistas, intriguingly shaped rocks and glittering Las Vegas, the Golden Gate Bridge and America's Danish Capital, Solvang."
	  }, {
	    title: "Aloha Discovery",
	    hero: _AlohaDiscovery2.default,
	    header: {
	      days: 20,
	      nights: 19,
	      start: "Los Angeles",
	      end: "Los Angeles",
	      breakfastText: " "
	    },
	    highlights: ["Enjoy a welcome reception where you will meet your fellow travelers", "Experience the low key coastal vibes of San Diego during day long sightseeing tour of the city", "Discover the famed mid-century architecture of “Hollywood’s desert retreat” during a visit to Palm Springs", "Gaze at the majesty of the Grand Canyon", "Relive American western film history, witnessing the iconic western landscapes of Monument Valley", "Capture the unique rock formations of Bryce Canyon National Park", "Enjoy leisure time for shopping, gambling, eating, or all of the above in glitzy Las Vegas", "Post an Instagram of yourself at the iconic “Welcome to Las Vegas” sign", "Traverse the lowest and driest spot within the western hemisphere: Death Valley National Park", "Explore the magnificent falls during a visit to majestic Yosemite National Park (weather permitting)", "Take in the sites of the City by the Bay, San Francisco, including the Golden Gate Bridge, Union Square and Fisherman’s Wharf", "Journey through America’s capital of technology innovation, Silicon Valley", "Experience the charming sites and sounds of Monterey including Cannery Row, inspiration for American author John Steinbeck", "Discover through the picturesque scenery of California’s central coast and its rich agricultural plains", "Enjoy a touch of Europe in the new world while visiting the Danish community of Solvang", "Stroll the Hollywood Walk of Fame and find your favorite celebrity’s star", "Get a glimpse of all the glamour Los Angeles has to offer with stops at some of its most famous spots", "Relax amidst the warm Aloha spirit of Hawaii and enjoy the tranquil sights and sounds of these island, with their world renowned tropical beauty"],
	    optionals: ["Hop on a harbor cruise of San Diego Bay", "Take flight over the magnificent Grand Canyon for unforgettable experience", "Jump into a Jeep and taking an in depth tour of Monument Valley", "Capture the intense colors and ethereal light of Antelope Canyon", "How about a boot stompin’ dinner with country music fun at Ebenezer’s Barn in Bryce Canyon", "Experience the glitz and glam of Las Vegas during an extensive evening tour", "Take a gondola ride to the summit Mammoth Mountain for a breakfast with sweeping views of the Sierra Mountains", "Hop on board a cable car during an extensive night tour of San Francisco and enjoy dinner tonight in the “City by the Bay”", "Ride a bike across the Golden Gate Bridge with vast views of the San Francisco Bay", "Enjoy a seafood feast during a Bubba Gump lunch at Santa Monica’s pier, the finish line of famed Route 66"],
	    body: "Enjoy all the scenic wonders of the American West, including the amazing landscapes of vast canyons, deserts, rock formations and mountains, as well as the glamorous cities and all their excitement, shopping, and entertainment before jetting off to Hawaii for tropical relaxation."
	  }, {
	    title: "Western Landscapes",
	    hero: _WesternLandscapes2.default,
	    header: {
	      days: 13,
	      nights: 12,
	      start: "Los Angeles",
	      end: "Los Angeles",
	      breakfastText: " "
	    },
	    highlights: ["Enjoy a welcome reception where you will meet your fellow travelers", "Experience the coastal vibes of San Diego during day long sightseeing tour of the city", "Discover the famed mid-century architecture of “Hollywood’s desert retreat” during a visit to Palm Springs", "Gaze at the majesty of the Grand Canyon", "Relive American western film history, witnessing the iconic western landscapes of Monument Valley", "Capture the unique rock formations of Bryce Canyon National Park", "Enjoy leisure time for shopping, gambling, eating, or all of the above in glitzy Las Vegas", "Post an Instagram of yourself at the iconic “Welcome to Las Vegas” sign", "Traverse the lowest and driest spot within the western hemisphere: Death Valley National Park", "Explore the magnificent falls during a visit to majestic Yosemite National Park (weather permitting)", "Take in the sites of the City by the Bay, San Francisco, including the Golden Gate Bridge, Union Square and Fisherman’s Wharf", "Journey through America’s capital of technology innovation, Silicon Valley", "Experience the charming sites and sounds of Monterey including Cannery Row, inspiration for American author John Steinbeck", "Discover through the picturesque scenery of California’s central coast and its rich agricultural plains", "Enjoy a touch of Europe in the new world while visiting the Danish community of Solvang", "Stroll the Hollywood Walk of Fame and find your favorite celebrity’s star", "Get a glimpse of all the glamour Los Angeles has to offer with stops at some of its most famous spots"],
	    optionals: ["Hop on a harbor cruise of San Diego Bay", "Take flight over the magnificent Grand Canyon for unforgettable experience", "Jump into a Jeep and taking an in depth tour of Monument Valley", "Capture the intense colors and ethereal light of Antelope Canyon", "How about a boot stompin’ dinner with country music fun at Ebenezer’s Barn in Bryce Canyon", "Experience the glitz and glam of Las Vegas during an extensive evening tour", "Take a gondola ride to the summit Mammoth Mountain for a breakfast with sweeping views of the Sierra Mountains", "Hop on board a cable car during an extensive night tour of San Francisco and enjoy dinner tonight in the “City by the Bay”", "Ride a bike across the Golden Gate Bridge with vast views of the San Francisco Bay", "Enjoy a seafood feast during a Bubba Gump lunch at Santa Monica’s pier, the finish line of famed Route 66"],
	    body: "Explore California from the Bay Area and back down, then head over to Viva Las Vegas where the fun never stops. Along the way, experience the grandeur of the Western United States."
	  }, {
	    title: "Splendors of the West",
	    hero: _SplendorsOfTheWest2.default,
	    header: {
	      days: 11,
	      nights: 10,
	      start: "Los Angeles",
	      end: "San Francisco",
	      breakfastText: " "
	    },
	    highlights: ["Enjoy a welcome reception where you will meet your fellow travelers", "Experience the coastal vibes of San Diego during day long sightseeing tour of the city", "Discover the famed mid-century architecture of “Hollywood’s desert retreat”  during a visit to Palm Springs", "Gaze at the majesty of the Grand Canyon", "Relive American western film history, witnessing the iconic western landscapes of Monument Valley", "Capture the unique rock formations of Bryce Canyon National Park", "Enjoy leisure time for shopping, gambling, eating, or all of the above in glitzy Las Vegas", "Post an Instagram of yourself at the iconic  “Welcome to Las Vegas” sign", "Traverse the lowest and driest spot within the western hemisphere: Death Valley National Park", "Explore the magnificent falls during a visit to majestic Yosemite National Park (weather permitting)", "Take in the sites and sounds of the City by the Bay, San Francisco, including the Golden Gate Bridge, Union Square, and Fisherman’s Wharf", "Ride a cable car during and extensive night tour of San Francisco and enjoy  an authentic local dinner prepared in the “City by the Bay”"],
	    optionals: ["Hop on a harbor cruise of San Diego Bay", "Take flight over the magnificent Grand Canyon for unforgettable experience", "Jump into a Jeep and taking an in depth tour of Monument Valley", "Capture the intense colors and ethereal light of Antelope Canyon", "How about a boot stompin’ dinner with country music fun at Ebenezer’s Barn in Bryce Canyon", "Experience the glitz and glam of Las Vegas during an extensive evening tour", "Take a gondola ride to the summit Mammoth Mountain for a breakfast with sweeping views of the Sierra Mountains", "Hop on board a cable car during an extensive night tour of San Francisco and enjoy dinner tonight in the “City by the Bay”", "Ride a bike across the Golden Gate Bridge with vast views of the San Francisco Bay"],
	    body: "This tour covers it all. From a seaside playground to unparalleled canyon vistas to Zion's intriguingly shaped rocks, glittering Las Vegas, and Giant Sequoias."
	  }, {
	    title: "Western Trails",
	    hero: _WesternTrails2.default,
	    header: {
	      days: 8,
	      nights: 7,
	      start: "Los Angeles",
	      end: "Los Angeles",
	      breakfastText: " "
	    },
	    highlights: ["Welcome Reception and meet your fellow travelers", "Visit “Hollywood’s desert retreat”: Palm Springs", "Gaze at the majestic Grand Canyon", "Tour a Navajo Indian Reservation and stop at Monument Valley", "Explore Bryce Canyon National Park", "Leisure time in vibrant Las Vegas", "Photo stop at the landmark “Welcome to Las Vegas” sign"],
	    optionals: ["Flights over the magnificent Grand Canyon", "Jeep tour in Monument Valley", "Antelope Canyon excursion", "Boot stompin’ dinner and fun at Ebenezer’s Barn & Grill", "Las Vegas evening tour"],
	    body: "Excitingly diverse excursion from a seaside playground and unparalleled canyon vistas to intriguingly shaped rocks and glittering Las Vegas!"
	  }, {
	    title: "Western Panorama",
	    hero: _WesternPanorama2.default,
	    header: {
	      days: 8,
	      nights: 7,
	      start: "Los Angeles",
	      end: "Los Angeles",
	      breakfastText: " "
	    },
	    highlights: ["Enjoy leisure time for shopping, gambling, eating, or all of the above in glitzy Las Vegas", "Post an Instagram of yourself at the iconic “Welcome to Las Vegas” sign", "Enjoy leisure time for shopping, gambling, eating, or all of the above in glitzy Las Vegas", "Traverse the lowest and driest spot within the western hemisphere: Death Valley National Park", "Explore the magnificent falls during a visit to majestic Yosemite National Park (weather permitting)", "Take in the sites of the City by the Bay, San Francisco, including the Golden Gate Bridge, Union Square and Fisherman’s Wharf", "Journey through America’s capital of technology innovation, Silicon Valley", "Experience the charming sites and sounds of Monterey including Cannery Row, inspiration for American author John Steinbeck", "Discover through the picturesque scenery of California’s central coast and its rich agricultural plains", "Enjoy a touch of Europe in the new world while visiting the Danish community of Solvang", "Stroll the Hollywood Walk of Fame and find your favorite celebrity’s star", "Get a glimpse of all the glamour Los Angeles has to offer with stops at some of its most famous spots"],
	    optionals: ["Take a gondola ride to the summit Mammoth Mountain for a breakfast with sweeping views of the Sierra Mountains", "Hop on board a cable car during an extensive night tour of San Francisco and enjoy dinner tonight in the “City by the Bay”", "Ride a bike across the Golden Gate Bridge with vast views of the San Francisco Bay", "Enjoy a seafood feast during a Bubba Gump lunch at Santa Monica’s pier, the finish line of famed Route 66"],
	    body: "Here's an enchantingly diverse excursion, from the unique sunken desert below sea level and glittering Vegas to fairytale Giant Sequoias, the Golden Gate Bridge, and America's Danish Capital!"
	  }, {
	    title: "Western Frontiers",
	    hero: _WesternFrontiers2.default,
	    header: {
	      days: 8,
	      nights: 7,
	      start: "Las Vegas",
	      end: "Las Vegas",
	      breakfastText: " "
	    },
	    highlights: ["Enjoy leisure time for shopping, gambling, eating, or all of the above in glitzy Las Vegas", "Post an Instagram of yourself at the iconic “Welcome to Las Vegas” sign", "Enjoy leisure time for shopping, gambling, eating, or all of the above in glitzy Las Vegas", "Traverse the lowest and driest spot within the western hemisphere: Death Valley National Park", "Explore the magnificent falls during a visit to majestic Yosemite National Park (weather permitting)", "Take in the sites of the City by the Bay, San Francisco, including the Golden Gate Bridge, Union Square and Fisherman’s Wharf", "Journey through America’s capital of technology innovation, Silicon Valley", "Experience the charming sites and sounds of Monterey including Cannery Row, inspiration for American author John Steinbeck", "Discover through the picturesque scenery of California’s central coast and its rich agricultural plains", "Enjoy a touch of Europe in the new world while visiting the Danish community of Solvang", "Stroll the Hollywood Walk of Fame and find your favorite celebrity’s star", "Get a glimpse of all the glamour Los Angeles has to offer with stops at some of its most famous spots"],
	    optionals: ["Take a gondola ride to the summit Mammoth Mountain for a breakfast with sweeping views of the Sierra Mountains", "Hop on board a cable car during an extensive night tour of San Francisco and enjoy dinner tonight in the “City by the Bay”", "Ride a bike across the Golden Gate Bridge with vast views of the San Francisco Bay", "Enjoy a seafood feast during a Bubba Gump lunch at Santa Monica’s pier, the finish line of famed Route 66"],
	    body: "Enjoy this 8 day tour that takes you throughout California and Nevada - America's western frontier! Along the way you will visit Death Valley, Yosemite, Carmel and Monterey as well as tour San Francisco, Los Angeles and Napa Valley wineries!"
	  }, {
	    title: "California Dreaming",
	    hero: _CaliforniaDreaming2.default,
	    header: {
	      days: 7,
	      nights: 6,
	      start: "Los Angeles",
	      end: "San Francisco",
	      breakfastText: " "
	    },
	    highlights: ["Post an Instagram of yourself at the iconic “Welcome to Las Vegas” sign", "Enjoy leisure time for shopping, gambling, eating, or all of the above in glitzy Las Vegas", "Traverse the lowest and driest spot within the western hemisphere: Death Valley National Park", "Explore the magnificent falls during a visit to majestic Yosemite National Park (weather permitting)", "Take in the sites of the City by the Bay, San Francisco, including the Golden Gate Bridge, Union Square and Fisherman’s Wharf"],
	    optionals: ["Take a gondola ride to the summit Mammoth Mountain for a breakfast with sweeping views of the Sierra Mountains", "Hop on board a cable car during an extensive night tour of San Francisco and enjoy dinner tonight in the “City by the Bay”", "Ride a bike across the Golden Gate Bridge with vast views of the San Francisco Bay", "Enjoy a seafood feast during a Bubba Gump lunch at Santa Monica’s pier, the finish line of famed Route 66"],
	    body: "Enjoy this scenic tour through the land of sun and fun! You'll start with the glitz and glamour of Los Angeles and Las Vegas, pass through the quietly beautiful Mojave Desert, see the majestic sights of Yosemite National Park and finally end with the marvelous city of San Francisco!"
	  }, {
	    title: "Pacific Coast Express",
	    hero: _PacificCoastExpress2.default,
	    header: {
	      days: 4,
	      nights: 3,
	      start: "Los Angeles",
	      end: "San Francisco",
	      breakfastText: " "
	    },
	    highlights: ["Visit Santa Barbara, “California’s Riviera”known for its Mediterranean flair", "Travel California’s central coast and its rich agricultural plains", "Visit Monterey including Cannery Row,inspiration for American author John Steinbeck", "Journey through one of America’s most renown technology hubs: Silicon Valley"],
	    optionals: ["Visit Universal Studios"],
	    body: "When it comes to America's best road trips, it's hard to beat the Pacific Coast Highway.  Cruise along stunning bluffs overlooking the Pacific, stopping at designated vista points for sparkling ocean views.  Add this to dozens of small and not-so-small towns and you'll experience some of California's highlights."
	  }, {
	    title: "California Explorer",
	    hero: _CaliforniaExplorer2.default,
	    header: {
	      days: 2,
	      nights: 1,
	      start: "San Francisco",
	      end: "Los Angeles",
	      breakfastText: " "
	    },
	    highlights: ["Journey through one of America’s most renown technology hubs: Silicon Valley", "Visit Monterey including Cannery Row,inspiration for American author John Steinbeck", "Travel California’s central coast and its rich agricultural plains", "Explore the Danish community of Solvang", "See Hollywood and its ‘Sidewalk of the Stars’", "Orientation tour of Los Angeles including stops at some of its most famous spots"],
	    optionals: ["Bubba Gump lunch at Santa Monica pier and the finish line of Route 66"],
	    body: "California possesses many charms, especially along its fabulous coastline. This quick getaway will introduce you to some of these striking havens by the sea."
	  }, {
	    title: "Western Highlights",
	    hero: _WesternHighlights2.default,
	    header: {
	      days: 11,
	      nights: 10,
	      start: "",
	      end: "",
	      breakfastText: " "
	    },
	    highlights: ["Enjoy a welcome reception where you will meet your fellow travelers", "Take in the sites and sounds of the City by the Bay, San Francisco, including the Golden Gate Bridge, Union Square, and Fisherman’s Wharf", "Feel the mists of the magnificent falls at Yosemite National Park (weather permitting)", "Traverse the Mojave Desert and see its indigenous Joshua Trees", "Enjoy leisure time for shopping, gambling, eating, or all of the above in glitzy Las Vegas", "Post an Instagram of yourself at the iconic “Welcome to Las Vegas” sign", "Witness the manmade majesty of Hoover Dam,the tallest in the United States", "Enjoy a full day excursion to the west Rim of the Grand Canyon, taking in its natural majesty", "Discover the famed mid-century architecture relaxed vibes of “Hollywood’s desert retreat” during a visit to Palm Springs", "Stroll the Hollywood Walk of Fame and find your favorite celebrity’s star", "Get a glimpse of all the glamour Los Angeles has to offer with stops at some of its most famous spots"],
	    optionals: ["Hop on board a cable car during an extensive night tour of San Francisco and enjoy dinner tonight in the “City by the Bay”", "Ride a bike across the Golden Gate Bridge with vast views of the San Francisco Bay", "Escape from the city to experience the natural beauty of Muir Woods and the quaint coastal hamlet of Sausalito", "Take a full day excursion to experience the charm of Monterey and Carmel,traversing portions of the famed 17 Mile drive in Pebble Beach", "Experience the glitz and glam of Las Vegas during an extensive evening tour", "Enjoy more of the excitement that Vegas has to offer with a dinner show", "Discover the vast majesty of the Grand Canyon from above with helicopter flight", "Fulfill a thrill seeker’s dream by walking above the Grand Canyon over the glass floors of the Skywalk", "Take a full day excursion from Las Vegas to experience the unparalleled natural beauty of Zion National Park", "Enjoy thrilling rides and a bit of Hollywood history during a half-day visit to Universal Studios", "Experience the coastal vibes of San Diego with a full day sightseeing tour of the city,including lunch"],
	    body: "Unearth the beauty and history that makes the West so special.  Large cities, such as San Francisco and Las Vegas, will delight tourists with their cosmopolitan flair, while the striking natural wonders of the land in Yosemite, Zion and Bryce Canyon have a special allure of their own."
	  }, {
	    title: "West Coast Aloha",
	    hero: _WestCoastAloha2.default,
	    header: {
	      days: 16,
	      nights: 15,
	      start: "San Francisco",
	      end: "Los Angeles",
	      breakfastText: " "
	    },
	    highlights: ["Welcome Reception and meet your fellow travelers", "Sightseeing tour of San Francisco including the Golden Gate Bridge, Union Square and Fisherman’s Wharf", "Walk to the magnificent Yosemite Falls (weather permitting)", "Travel through the Mojave Desert and see its indigenous Joshua Trees", "Photo stop at the landmark “Welcome to Las Vegas” sign", "Leisure time in vibrant Las Vegas", "Visit for a picture stop at the Hoover Dam", "Full day excursion to the western Rim of the Grand Canyon", "Visit “Hollywood’s desert retreat”: Palm Springs", "See Hollywood and its ‘Sidewalk of the Stars’", "Orientation tour of Los Angeles including stops at some of its most famous spots", "Enjoy the sights and sounds of beautiful & tranquil Hawaii"],
	    optionals: ["Night tour of San Francisco with dinner including a cable car ride", "Bike ride across the famous Golden Gate Bridge", "Tour of Muir Woods and Sausalito", "Full day excursion to Monterey and Carmel,including 17-mile drive", "Las Vegas evening tour", "Las Vegas show and dinner", "Grand Canyon helicopter flight", "Grand Canyon Skywalk", "Full day excursion to Zion National Park", "Half day visit to Universal Studios", "Day visit and tour of San Diego, including lunch"],
	    body: "Explore the West Coast and gain a firsthand feel for the big cities and National Parks before your excursion over to Hawaii, a grand jewel in the Pacific."
	  }, {
	    title: "Western Bonanza",
	    hero: _WesternBonanza2.default,
	    header: {
	      days: 18,
	      nights: 17,
	      start: "San Francisco",
	      end: "Los Angeles or San Francisco",
	      breakfastText: "(Daily Breakfast)"
	    },
	    highlights: ["Enjoy a welcome reception where you will meet your fellow travelers", "Take in the sites and sounds of the City by the Bay, San Francisco, including the Golden Gate Bridge, Union Square, and Fisherman’s Wharf", "Discover California’s State Capital, Sacramento, and get a sense of the Golden state’s young but rich history", "Travel along the shores of Lake Tahoe and enjoy picturesque stops en route", "Stroll the glitzy main street of the ‘Biggest Little City in the World’, Reno", "Transport yourself to another planet, exploring the Craters of the Moon National Monument", "Discover the limitless natural majesty of the world’s first National Park, Yellowstone", "Witness the stunning rugged peaks of the Grand Teton Mountain Range", "Experience Salt Lake City including Temple Square, home to the Mormon Tabernacle", "Capture the ethereal mountain landscapes of Arches and Canyonlands National Parks", "Explore the unique rock formations of Bryce Canyon National Park", "Gaze at the majestic Grand Canyon", "Traverse historic Route 66, stopping at the iconic roadside town of Seligman", "Enjoy leisure time for shopping, gambling, eating, or all of the above in glitzy Las Vegas", "Post an Instagram of yourself at the iconic “Welcome to Las Vegas” sign", "Stroll the Hollywood Walk of Fame and find your favorite celebrity’s star", "Get a glimpse of all the glamour Los Angeles has to offer with stops at some of its most famous spots", "Enjoy Santa Barbara, “California’s Riviera” known for its Mediterranean flair", "Discover through the picturesque scenery of California’s central coast and its rich agricultural plains", "Experience the charming sites and sounds of Monterey including Cannery Row, inspiration for American author John Steinbeck", "Journey through America’s capital of technology innovation, Silicon Valley"],
	    optionals: ["Hop on board a cable car during an extensive night tour of San Francisco and enjoy dinner this evening in the “City by the Bay”", "Ride a bike across the Golden Gate Bridge with vast views of the San Francisco Bay", "Escape from the city to experience the natural beauty of Muir Woods and the quaint coastal hamlet of Sausalito", "Fulfill a bit of adventure with a jet boat ride on the Colorado River", "Enjoy a dinner at a rooftop restaurant in Salt Lake City with panoramic views of Temple Square", "Discover the vast majesty of the Grand Canyon from above with helicopter flight", "Fly over scenic Lake Powell and enjoy western film landscapes of Monument Valley during a tour", "Experience the glitz and glam of Las Vegas during an extensive evening tour", "Enjoy more of the excitement that Vegas has to offer with a dinner show", "Take an excursion to Death Valley National Park", "Enjoy a seafood feast during a dinner at Bubba Gump, an American food and film classic", "Enjoy thrilling rides and a bit of Hollywood history during a half-day visit to Universal Studios"],
	    body: "Observe the sights that make the American West so alluring. Lake Tahoe, Yellowstone, Grand Canyon, and Craters of the Moon epitomize the beauty of the land, while Las Vegas, San Francisco, and Los Angeles all portray a triumph of man-made sophistication."
	  }, {
	    title: "National Parks Explorer",
	    hero: _NationalParksExplorer2.default,
	    header: {
	      days: 15,
	      nights: 14,
	      start: "San Francisco",
	      end: "Los Angeles",
	      breakfastText: ""
	    },
	    highlights: ["Enjoy a welcome reception where you will meet your fellow travelers", "Take in the sites and sounds of the City by the Bay, San Francisco, including the Golden Gate Bridge, Union Square, and Fisherman’s Wharf", "Discover California’s State Capital, Sacramento,and get a sense of the Golden state’s young but rich history", "Travel along the shores of Lake Tahoe and enjoy picturesque stops en route", "Stroll the glitzy main street of the ‘Biggest Little City in the World’, Reno", "Transport yourself to another planet, exploring the Craters of the Moon National Monument", "Discover the limitless natural majesty of the world’s first National Park, Yellowstone", "Witness the stunning rugged peaks of the Grand Teton Mountain Range", "Experience Salt Lake City including Temple Square, home to the Mormon Tabernacle", "Capture the ethereal mountain landscapes of Arches and Canyonlands National Parks", "Explore the unique rock formations of Bryce Canyon National Park", "Gaze at the majestic Grand Canyon", "Traverse historic Route 66, stopping at the iconic roadside town of Seligman", "Enjoy leisure time for shopping, gambling, eating, or all of the above in glitzy Las Vegas", "Post an Instagram of yourself at the iconic “Welcome to Las Vegas” sign", "Stroll the Hollywood Walk of Fame and find your favorite celebrity’s star", "Get a glimpse of all the glamour Los Angeles has to offer with stops at some of its most famous spots"],
	    optionals: ["Hop on board a cable car during an extensive night tour of San Francisco and enjoy dinner this evening in the “City by the Bay”", "Ride a bike across the Golden Gate Bridge with vast views of the San Francisco Bay", "Escape from the city to experience the natural beauty of Muir Woods and the quaint coastal hamlet of Sausalito", "Fulfill a bit of adventure with a jet boat ride on the Colorado River", "Enjoy a dinner at a rooftop restaurant in Salt Lake City with panoramic views of Temple Square", "Discover the vast majesty of the Grand Canyon from above with helicopter flight", "Fly over scenic Lake Powell and enjoy western film landscapes of Monument Valley during a tour", "Experience the glitz and glam of Las Vegas during an extensive evening tour", "Enjoy more of the excitement that Vegas has to offer with a dinner show", "Take an excursion to Death Valley National Park"],
	    body: "The southwestern United States features the most unique landscape in the world. See these stunning land formations as they are continually preserved for many generations, past, present, and future."
	  }, {
	    title: "National Parks Treasures",
	    hero: _NationalParksTreasures2.default,
	    header: {
	      days: 7,
	      nights: 6,
	      start: "Salt Lake City",
	      end: "Las Vegas",
	      breakfastText: " "
	    },
	    highlights: ["Visit 2 of Utah’s most famous National Parks:Arches and Canyonlands", "Explore Bryce Canyon National Park", "Gaze at the majestic Grand Canyon", "Travel the historic Route 66, stopping at the iconic town of Seligman", "Photo stop at the landmark “Welcome to Las Vegas” sign", "Leisure time in vibrant Las Vegas"],
	    optionals: ["Experience a jet boat ride on the Colorado River", "Grand Canyon helicopter flight", "Fly over Lake Powell and enjoy a Monument Valley tour", "Las Vegas evening Tour"],
	    body: "Arches, Canyonlands, Capitol Reef, Bryce and the Grand Canyon ... Discover these varied but equally beautiful national gems packed with extraordinary natural wonders, history, hiking trails, places to get lost and hidden treasures to be found.  These parks of grandeur will inspire the imagination and stir the soul."
	  }, {
	    title: "North by Northwest",
	    hero: _NorthByNorthwest2.default,
	    header: {
	      days: 18,
	      nights: 17,
	      start: "Denver",
	      end: "San Francisco",
	      breakfastText: " "
	    },
	    highlights: ["Enjoy a welcome reception where you will meet your fellow travelers", "Discover the “mile high” city of Denver including the famed Red Rocks Amphitheatre", "Travel along the America’s highest highway through Rocky Mountain National Park", "Discover the limitless natural majesty of the world’s first National Park, Yellowstone", "Traverse the Going-to-the-Sun Road in the seemingly untouched Glacier National Park", "Visit Banff a UNESCO World Heritage Site and Canada’s first National Park", "Stroll along the turquoise waters of Lake Louise", "Experience the perfect mix of cityscape and natural beauty with a tour of Vancouver and its harbor front", "Discover the “the Emerald City” of Seattle,known for its greenery and as a global hub for innovation and technology", "Visit majestic Mt. Rainier National Park and the Mt. St. Helens volcano", "Traverse the stunning and rugged Oregon Coastline along the northern portion of the Pacific Coast Highway", "Explore Redwood National Park and touch some of the tallest and oldest trees in the world", "Enjoy California’s Wine country and taste the world renowned vintages of Sonoma County"],
	    optionals: ["Capture a glacier from above with a helicopterflight from Canmore", "Hop aboard a snowcoach for an adventure through the Columbia Icefield", "Take a day excursion to the experience the European sensibility of Vancouver Island and its beautifully manicured Butchart Gardens", "Enjoy a cruise around the pristine shores of Seattle", "See the city of San Francisco from sea with a Bay Cruise"],
	    body: "Explore the beauty of the Northwest. Stunning landscape will be your guide as you cross borders between states and countries traveling within Colorado, Montana, Wyoming, Alberta, British Colombia, Washington, Oregon and California. It will be a trip to remember!"
	  }, {
	    title: "Rocky Mountain Discovery",
	    hero: _RockyMountainDiscovery2.default,
	    header: {
	      days: 13,
	      nights: 12,
	      start: "Denver",
	      end: "Vancouver, B.C.",
	      breakfastText: " "
	    },
	    highlights: ["Enjoy a welcome reception where you will meet your fellow travelers", "Discover the “mile high” city of Denver including the famed Red Rocks Amphitheatre", "Travel along the America’s highest highway through Rocky Mountain National Park", "Discover the limitless natural majesty of the world’s first National Park, Yellowstone", "Traverse the Going-to-the-Sun Road in the seemingly untouched Glacier National Park", "Visit Banff a UNESCO World Heritage Site and Canada’s first National Park", "Stroll along the turquoise waters of Lake Louise", "Experience the perfect mix of cityscape and natural beauty with a tour of Vancouver and its harbor front", "Leisure time in beautiful Vancouver"],
	    optionals: ["Canmore’s glacier helicopter flight", "Columbia Icefield snowcoach adventure", "Victoria and Butchart Gardens"],
	    body: "Stretching between the United States and Canada, the Rocky Mountains hold the Continental Divide and draw guests from around the world who wish to climb its peaks, study its wildlife or simply take in its spectacular views."
	  }, {
	    title: "Pacific Coast Explorer",
	    hero: _PacificCoastExplorer2.default,
	    header: {
	      days: 9,
	      nights: 8,
	      start: "Vancouver",
	      end: "San Francisco"
	    },
	    highlights: ["Discover the “the Emerald City” of Seattle, known for its greenery and as a global hub for innovation and technology", "Visit majestic Mt. Rainier National Park and the Mt. St. Helens volcano", "Traverse the stunning and rugged Oregon Coastline along the northern portion of the Pacific Coast Highway", "Explore Redwood National Park and touch some of the tallest and oldest trees in the world", "Enjoy California’s Wine country and taste the world renowned vintages of Sonoma County"],
	    optionals: ["Take a day excursion to the experience the European sensibility of Vancouver Island and its beautifully manicured Butchart Gardens", "Enjoy a cruise around the pristine shores of Seattle", "See the city of San Francisco from sea with a Bay Cruise"],
	    body: "From the towering Redwoods of Northern California to beautiful British Columbia, and the distinct metropolises in between, the Pacific Northwest offers countless awe-inspiring destinations sure to satisfy any traveler."
	  }]
	}];
	module.exports = exports["default"];

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(6);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _TourDisplay = __webpack_require__(80);
	
	var _TourDisplay2 = _interopRequireDefault(_TourDisplay);
	
	var _escortedTours__hero = __webpack_require__(496);
	
	var _escortedTours__hero2 = _interopRequireDefault(_escortedTours__hero);
	
	var _mcxTours = __webpack_require__(188);
	
	var _mcxTours2 = _interopRequireDefault(_mcxTours);
	
	var _escorted_tours = __webpack_require__(497);
	
	var _escorted_tours2 = _interopRequireDefault(_escorted_tours);
	
	var _escorted_tours3 = __webpack_require__(498);
	
	var _escorted_tours4 = _interopRequireDefault(_escorted_tours3);
	
	var _escorted_tours5 = __webpack_require__(499);
	
	var _escorted_tours6 = _interopRequireDefault(_escorted_tours5);
	
	var _escorted_tours7 = __webpack_require__(500);
	
	var _escorted_tours8 = _interopRequireDefault(_escorted_tours7);
	
	var _escorted_tours9 = __webpack_require__(501);
	
	var _escorted_tours10 = _interopRequireDefault(_escorted_tours9);
	
	var _escorted_tours11 = __webpack_require__(502);
	
	var _escorted_tours12 = _interopRequireDefault(_escorted_tours11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: "Escorted Tours | What We Offer"
	      // meta={[{ name: 'description', content: '' }]}
	    }),
	    _react2.default.createElement(
	      _Header2.default,
	      { hero: _escortedTours__hero2.default },
	      _react2.default.createElement(
	        "h1",
	        { className: "t-hero" },
	        "Escorted Tours"
	      )
	    ),
	    _react2.default.createElement(
	      "main",
	      { id: "content" },
	      _react2.default.createElement(
	        "div",
	        { className: "c-golden t-context--light" },
	        _react2.default.createElement(
	          "div",
	          { className: "c-golden__images c-golden__short min-laptop" },
	          _react2.default.createElement("img", {
	            src: _escorted_tours2.default,
	            alt: "",
	            style: { width: "50%", height: "100%" }
	          }),
	          _react2.default.createElement("img", {
	            src: _escorted_tours4.default,
	            alt: "",
	            style: { width: "50%", height: "50%" }
	          }),
	          _react2.default.createElement("img", {
	            src: _escorted_tours6.default,
	            alt: "",
	            style: { width: "50%", height: "50%" }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "c-golden__content c-golden__wide" },
	          _react2.default.createElement(
	            "ul",
	            { className: "c-breadcrumbs mb30" },
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/" },
	                "Home"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/what-we-offer" },
	                "What We Offer"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  to: "/what-we-offer/escorted-tours",
	                  activeClassName: "is-active"
	                },
	                "Escorted Tours"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "c-golden__text" },
	            _react2.default.createElement(
	              "div",
	              { className: "c-golden__text-col" },
	              _react2.default.createElement(
	                "h1",
	                { className: "t-h1" },
	                "Sit back relax and enjoy"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "t-p t-p-light mt30" },
	                "What better way to explore America than by escorted motor coach, allowing you to sit back relax and enjoy the breathtaking scenery while learning about the history and culture of the destination from your expert Tour Director, all while making new friends with fellow travelers along the way. ATI continues to deliver the most extensive set of North American escorted programs in the industry, discovering new destinations and finding the ideal tour selection for both first-time as well as repeat visitors."
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "t-p t-p-light mt30" },
	                "Core to the success of our escorted tour program is the excellence of our industry leading Tour Directors, who are trained and employed by ATI to deliver an enjoyable, educational, and memorable experience to our tour passengers."
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_TourDisplay2.default, {
	        items: _mcxTours2.default,
	        images: [_escorted_tours8.default, _escorted_tours10.default, _escorted_tours12.default],
	        text: "Escorted Tour Routes:"
	      })
	    )
	  );
	};
	
	exports.default = Page;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-what-we-offer-escorted-tours-js-4812efdeca8a3fff3b92.js